import React, {useEffect} from 'react'
import {useLocation} from 'react-router-dom'

import {AsideDefault} from './components/aside/AsideDefault'
import {Footer} from './components/Footer'
import HeaderWrapper from './components/header/HeaderWrapper'
import {ScrollTop} from './components/ScrollTop'
import {Content} from './components/Content'
import {PageDataProvider} from './core'
import {MenuComponent} from '../assets/ts/components'

const MasterLayout: React.FC = ({children}) => {
  const location = useLocation()
  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [])

  useEffect(() => {
    setTimeout(() => {
      MenuComponent.reinitialization()
    }, 500)
  }, [location.key])

  return (
    <PageDataProvider>
      <div className='page d-flex flex-row flex-column-fluid'>
        <AsideDefault />
        {/* overflow-x:clip (NOT hidden) kills the Bootstrap row negative-margin horizontal scroll on mobile
            WITHOUT forcing overflow-y:auto — so absolutely-positioned header popovers (e.g. the inspector
            search-results dropdown) overflow downward freely instead of being clipped. */}
        <div className='wrapper d-flex flex-column flex-row-fluid' id='kt_wrapper' style={{overflowX: 'clip'}}>
          <HeaderWrapper />

          <div id='kt_content' className='content d-flex flex-column flex-column-fluid'>
            {/* Toolbar removed: breadcrumb/PageTitle bar was empty and wasted vertical space */}
            {/* <div className='post d-flex flex-column-fluid' id='kt_post'> */}
            <div id='kt_post' className='h-100'>
              <Content>{children}</Content>
            </div>
          </div>
          <Footer />
        </div>
      </div>

      <ScrollTop />
    </PageDataProvider>
  )
}

export {MasterLayout}
